var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEgg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 0C86 0 0 214 0 320S86 512 192 512C298 512 384 426 384 320S298 0 192 0ZM192 464C112.625 464 48 399.375 48 320C48 202.625 138.625 48 192 48S336 202.625 336 320C336 399.375 271.375 464 192 464ZM168.027 103.984C160.729 103.984 153.914 107.246 149.332 112.934C113.953 156.756 76.342 238.615 76.342 304.002C76.342 317.234 87.109 328.002 100.342 328.002C113.578 328.002 124.344 317.234 124.344 304.002C124.344 251.58 156.045 181.012 186.691 143.074C194.994 132.785 193.379 117.648 183.096 109.326C178.848 105.883 173.494 103.984 168.027 103.984Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.2f640f65197870a46554ee4229cb02a6.svg";
export { ForwardRef as ReactComponent };